import React from "react";
import PropTypes from "prop-types";

import { css } from "glamor";
import { Button } from "antd";

const styles = {
    ghost: css({
        padding: "8px 24px",
        height: "auto",
    }),
    darkBg: css({
        ".ant-btn[disabled]": {
            borderColor: "#ffffff50",
            color: "#ffffff50",
        },
    }),
};

const Ghost = ({ children, darkbg, ...otherProps }) => {
    const buttonStyles = darkbg
        ? css(styles.ghost, styles.darkBg)
        : styles.ghost;
    return (
        <Button {...buttonStyles} ghost {...otherProps}>
            {children}
        </Button>
    );
};

Ghost.propTypes = {
    children: PropTypes.string.isRequired,
};

export default Ghost;
